import { render, staticRenderFns } from "./MethodologyModal.vue?vue&type=template&id=3108d706&scoped=true"
import script from "./MethodologyModal.vue?vue&type=script&lang=ts"
export * from "./MethodologyModal.vue?vue&type=script&lang=ts"
import style0 from "./MethodologyModal.vue?vue&type=style&index=0&id=3108d706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3108d706",
  null
  
)

export default component.exports